import React, { useEffect, useState } from "react";
import { Container, Row, Col, Input, Button, Modal, ModalBody } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Handler from "../../Helpers/Handler";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import { setStep, setForm, resetProfile } from "../../Reducer/profileSlice";
import Logo from "../../Assets/images/q-nexus.png";
import { reloadWindowToPath } from "../../Helpers/Utils";


const CreateProfile = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [imageType, setImageType] = useState(null);
  const dispatch = useDispatch();
  const profile = useSelector(s => s.profile || {});
  const step = profile.step || 1;
  const form = profile.form || {};


  /* BACK */
  const back = () => step > 1 && dispatch(setStep(step - 1));

  /* FILE CHANGE */
  const fileChange = e => {
    const { name, files } = e.target;
    dispatch(setForm({ [name]: files[0] }));
  };

  /* STEP VALIDATION */
  const submit = () => {
    if (step === 1) {
      if (!form.business_name) return toast.error("Business name is required");
      if (!form.short_bio) return toast.error("Short bio is required");
      dispatch(setStep(2)); return;
    }
    if (step === 2) {
      if (!form.category_id) return toast.error("Business category is required");
      if (!form.sub_category_id) return toast.error("Sub category is required");
      dispatch(setStep(3)); return;
    }
    if (step === 3) {
      if (!form.area) return toast.error("Area is required");
      if (!form.city) return toast.error("City is required");
      if (!form.phone) return toast.error("Phone number is required");
      if (!/^[6-9]\d{9}$/.test(form.phone))
        return toast.error("Invalid phone number");
      dispatch(setStep(4)); return;
    }
    if (step === 4) {
      if (!form.logo) return toast.error("Logo is required");
      setPreviewOpen(true);   // 🔥 PREVIEW
    }
  };

  /* FINAL SUBMIT */
  const finalSubmit = async () => {
    const fd = new FormData();
    Object.keys(form).forEach(k => { if (form[k]) fd.append(k, form[k]); });

    dispatch(loadingTrue());
    try {
      const r = await Handler({
        method: "post",
        url: "/users/create.php",
        data: fd,
        headers: { "Content-Type": "multipart/form-data" }
      });
      if (!r?.success) {
        dispatch(loadingFalse());
        return toast.error(r?.message || "Failed");
      }
      toast.success("Profile created successfully");
      reloadWindowToPath('/user/feed')
      dispatch(loadingFalse());
      setPreviewOpen(false);
      dispatch(resetProfile());
    } catch (e) {
      dispatch(loadingFalse());
      Handler(e);
    }
  };

  useEffect(() => {
    const loadCats = async () => {
      dispatch(loadingTrue());
      const r = await Handler({ method: "get", url: "/category/cat_list.php" });
      dispatch(loadingFalse());
      if (r?.success) {
        console.log(r?.data, '+++++++++')
        setCategories(r?.data?.list?.map(c => ({ value: c.id, label: c.name })));
      }
    };
    loadCats();
  }, [dispatch]);

  useEffect(() => {
  dispatch(resetProfile());
}, []);

  useEffect(() => {
    if (!form.category_id) {
      setSubCategories([]);
      dispatch(setForm({ sub_category_id: null }));
      return;
    }

    const loadSubs = async () => {
      dispatch(loadingTrue());
      const r = await Handler({
        method: "get",
        url: `/category/sub_list.php?category_id=${form.category_id}`
      });
      dispatch(loadingFalse());
      if (r?.success) {
        setSubCategories(r?.data?.list?.map(s => ({ value: s.id, label: s.name })));
      }
    };
    loadSubs();
  }, [form.category_id, dispatch]);


  return (
    <div className="qnexus-page">

      <div className="qnexus-top">
        <img src={Logo} className="qnexus-logo" alt="Qnexus" />
      </div>

      <Container>
        <Row className="justify-content-center">
          <Col md={8}>
            <div className="qnexus-card-lg">
              <div className="qnexus-head">
                <span className="back" onClick={back}>←</span>
                <h2>Create Profile</h2>
                <span className="step">Step {step} of 4</span>
              </div>

              {/* STEP 1 */}
              {step === 1 && (
                <>
                  <label>Business Name</label>
                  <Input
                    placeholder="Enter business name"
                    value={form.business_name || ""}
                    onChange={e => dispatch(setForm({ business_name: e.target.value }))}
                  />

                  <label>Short Bio</label>
                  <Input
                    type="textarea" rows={3}
                    placeholder="Write a short description"
                    value={form.short_bio || ""}
                    onChange={e => dispatch(setForm({ short_bio: e.target.value }))}
                  />
                </>
              )}

              {/* STEP 2 */}
              {step === 2 && (
                <>
                  <label>Business Category</label>
                  <Select options={categories} classNamePrefix={'profileselect'}
                    value={categories?.find(o => o.value === form.category_id) || null}
                    onChange={v => dispatch(setForm({ category_id: v.value }))} />

                  <label>Sub Category</label>
                  <Select options={subCategories} isDisabled={!form.category_id} classNamePrefix={'profileselect'}
                    value={subCategories?.find(o => o.value === form.sub_category_id) || null}
                    onChange={v => dispatch(setForm({ sub_category_id: v.value }))} />
                </>
              )}

              {/* STEP 3 */}
              {step === 3 && (
                <>
                  <label>Area</label>
                  <Input placeholder="Business area" value={form.area || ""}
                    onChange={e => dispatch(setForm({ area: e.target.value }))} />

                  <label>City</label>
                  <Input placeholder="City" value={form.city || ""}
                    onChange={e => dispatch(setForm({ city: e.target.value }))} />

                  <label>Phone</label>
                  <Input placeholder="+91 9876543210" maxLength={10} value={form.phone || ""}
                    onChange={e => dispatch(setForm({ phone: e.target.value }))} />

                  <label>Website</label>
                  <Input placeholder="https://example.com" value={form.website || ""}
                    onChange={e => dispatch(setForm({ website: e.target.value }))} />
                </>
              )}

              {/* STEP 4 */}
              {/* STEP 4 */}
              {step === 4 && (
                <>
                  <label>Logo <span style={{ color: "#ffa63b" }}>*</span></label>
                  <div
                    className={`upload-card ${form.logo instanceof File ? "upload-card--filled" : ""}`}
                    onClick={() => document.getElementById("logoInput").click()}
                  >
                    {form.logo instanceof File ? (
                      <>
                        <img src={URL.createObjectURL(form.logo)} alt="logo" className="upload-card__preview" />
                        <div className="upload-card__overlay">
                          <i className="bx bx-edit-alt" />
                          <span>Change Logo</span>
                        </div>
                      </>
                    ) : (
                      <div className="upload-card__placeholder">
                        <div className="upload-card__icon-wrap">
                          <i className="bx bx-image-add" />
                        </div>
                        <p className="upload-card__title">Click to upload logo</p>
                        <p className="upload-card__hint">PNG, JPG or WEBP • Recommended 400×400</p>
                      </div>
                    )}
                    <input
                      id="logoInput"
                      type="file"
                      name="logo"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={fileChange}
                    />
                  </div>

                  <label style={{ marginTop: 24 }}>Cover Image</label>
                  <div
                    className={`upload-card upload-card--wide ${form.cover_image instanceof File ? "upload-card--filled" : ""}`}
                    onClick={() => document.getElementById("coverInput").click()}
                  >
                    {form.cover_image instanceof File ? (
                      <>
                        <img src={URL.createObjectURL(form.cover_image)} alt="cover" className="upload-card__preview upload-card__preview--cover" />
                        <div className="upload-card__overlay">
                          <i className="bx bx-edit-alt" />
                          <span>Change Cover</span>
                        </div>
                      </>
                    ) : (
                      <div className="upload-card__placeholder">
                        <div className="upload-card__icon-wrap">
                          <i className="bx bx-landscape" />
                        </div>
                        <p className="upload-card__title">Click to upload cover image</p>
                        <p className="upload-card__hint">PNG, JPG or WEBP • Recommended 1200×400</p>
                      </div>
                    )}
                    <input
                      id="coverInput"
                      type="file"
                      name="cover_image"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={fileChange}
                    />
                  </div>
                </>
              )}

            </div>

            <div className="btn-wrap">
              <Button className="qnexus-btn" onClick={submit}>
                {step === 4 ? "Preview" : "Next"}
              </Button>
            </div>

          </Col>
        </Row>
      </Container>

      {/* 🔥 PREVIEW MODAL */}
      <Modal isOpen={previewOpen} size="lg" centered>
        <ModalBody>

          <h3 style={{ marginBottom: 20 }}>Preview Profile</h3>

          <Row className="g-3">

            <Col xs={12} md={6}>
              <label>Business Name</label>
              <Input readOnly value={form.business_name || ""} />
            </Col>

            <Col xs={12} md={6}>
              <label>Short Bio</label>
              <Input type="textarea" rows={2} readOnly value={form.short_bio || ""} />
            </Col>

            <Col xs={12} md={6}>
              <label>Business Category</label>
              <Select
                isDisabled
                options={categories}
                value={categories?.find(o => o.value === form.category_id) || null}
              />
            </Col>

            <Col xs={12} md={6}>
              <label>Sub Category</label>
              <Select
                isDisabled
                options={subCategories}
                value={subCategories?.find(o => o.value === form.sub_category_id) || null}
              />
            </Col>

            <Col xs={12} md={6}>
              <label>Area</label>
              <Input readOnly value={form.area || ""} />
            </Col>

            <Col xs={12} md={6}>
              <label>City</label>
              <Input readOnly value={form.city || ""} />
            </Col>

            <Col xs={12} md={6}>
              <label>Phone</label>
              <Input readOnly value={form.phone || ""} />
            </Col>

            <Col xs={12} md={6}>
              <label>Website</label>
              <Input readOnly value={form.website || ""} />
            </Col>

            {/* IMAGE ACTIONS ONLY */}
            <Col xs={12} md={6}>
              <label>Logo</label>
              <div>
                <Button
                  outline
                  disabled={!(form.logo instanceof File)}
                  onClick={() => { setImageType("logo"); setImagePreviewOpen(true); }}
                >
                  View Logo
                </Button>
              </div>
            </Col>

            <Col xs={12} md={6}>
              <label>Cover Image</label>
              <div>
                <Button
                  outline
                  disabled={!(form.cover_image instanceof File)}
                  onClick={() => { setImageType("cover"); setImagePreviewOpen(true); }}
                >
                  View Cover Photo
                </Button>
              </div>
            </Col>

            <Col xs={12} style={{ marginTop: 30, textAlign: "right" }}>
              <Button outline onClick={() => setPreviewOpen(false)}>Edit</Button>{" "}
              <Button color="warning" onClick={finalSubmit}>Submit</Button>
            </Col>

          </Row>

        </ModalBody>
      </Modal>
      <Modal isOpen={imagePreviewOpen} size="lg" centered toggle={() => setImagePreviewOpen(false)}>
        <ModalBody style={{ padding: 0 }}>

          {imageType === "logo" && form.logo instanceof File && (
            <img
              src={URL.createObjectURL(form.logo)}
              alt="logo"
              style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
            />
          )}

          {imageType === "cover" && form.cover_image instanceof File && (
            <img
              src={URL.createObjectURL(form.cover_image)}
              alt="cover"
              style={{ width: "100%", height: "80vh", objectFit: "cover" }}
            />
          )}

        </ModalBody>
      </Modal>


    </div>
  );
};

export default CreateProfile;
